// Vignettes panier LC (_LC Preview) — page /cart, tiroir, notification
(function () {
  var PREVIEW_KEYS = ['_LC Preview', '_Custom Thumbnail'];

  function getPreviewUrl(props) {
    if (!props) return '';
    for (var i = 0; i < PREVIEW_KEYS.length; i++) {
      var v = props[PREVIEW_KEYS[i]];
      if (v && (String(v).indexOf('data:image') === 0 || String(v).indexOf('http') === 0)) {
        return String(v);
      }
    }
    return '';
  }

  function ensurePreviewImg(mediaEl, previewUrl, alt) {
    if (!mediaEl || !previewUrl) return;
    var existing = mediaEl.querySelector('img.lc-cart-preview-img');
    if (existing && existing.getAttribute('src') === previewUrl) return;

    var wrap = mediaEl.querySelector('.lc-cart-preview-wrap');
    if (!wrap) {
      wrap = document.createElement('div');
      wrap.className = 'cart-item__image-container gradient global-media-settings lc-cart-preview-wrap';
      wrap.style.maxWidth = '150px';
      mediaEl.insertBefore(wrap, mediaEl.firstChild);
    }
    var img = wrap.querySelector('img.lc-cart-preview-img');
    if (!img) {
      img = document.createElement('img');
      img.className = 'cart-item__image lc-cart-preview-img';
      img.loading = 'lazy';
      img.width = 150;
      img.height = 150;
      img.style.objectFit = 'contain';
      img.style.background = '#fff';
      wrap.appendChild(img);
    }
    img.src = previewUrl;
    img.alt = alt || '';
  }

  function lineFromItem(item) {
    if (item.line != null) return item.line;
    if (item.index != null) return item.index + 1;
    return null;
  }

  function findMediaForLine(line) {
    var row = document.getElementById('CartItem-' + line) ||
      document.getElementById('CartDrawer-Item-' + line);
    if (!row) return null;
    return row.querySelector('.cart-item__media .cart__media') ||
      row.querySelector('.lc-cart-drawer-media') ||
      row.querySelector('.cart-item__media');
  }

  function enhanceFromCart(cart) {
    if (!cart || !cart.items || !cart.items.length) return;
    cart.items.forEach(function (item) {
      var preview = getPreviewUrl(item.properties);
      if (!preview) return;
      var line = lineFromItem(item);
      if (line == null) return;
      var media = findMediaForLine(line);
      ensurePreviewImg(media, preview, item.product_title || item.title || '');
    });
  }

  function run() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(enhanceFromCart)
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  document.addEventListener('lc:cart-added', function () {
    setTimeout(run, 120);
  });
  document.addEventListener('cart:refresh', run);
  if (typeof window !== 'undefined') {
    window.lcEnhanceCartPreviewImages = run;
  }
})();
